import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'loyal-react'
import { Link } from 'react-router-dom'

const Items = ({ label, click, index, icon, items, path, closeMenu, type }) => {
  return items.length === 0 && path
    ? <li className='px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'>
      <div className='row'>
        <div className='col-12 px-0' onClick={() => closeMenu()}>
          {
            type === 'external' ? (
              <a role='link' href={path} aria-label={label} className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'>
                <div className='row align-items-center h-100 pos-relative' aria-hidden='true'>
                  <div className='col ml-2 pt-half'>{label}</div>
                  <div className='col-auto' aria-hiden='true'>
                    <div className='row mx-0'>
                      <div className='col-auto px-0 mx-auto'>
                        <Icon iconName='icon-sm' className='icon_right invisible_icon' aria-hidden='true' />
                      </div>
                    </div>
                  </div>
                  <span className='hide-absolute'>Este é um link externo. Ao clicar nele, você será direcionado para outo site em uma nova aba no seu navegador.</span>
                </div>
              </a>
            ) : (
              <Link role='link' to={path} aria-label={label} className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'>
                <div className='row align-items-center h-100 pos-relative' aria-hidden='true'>
                  <div className='col ml-2 pt-half'>{label}</div>
                  <div className='col-auto' aria-hiden='true'>
                    <div className='row mx-0'>
                      <div className='col-auto px-0 mx-auto'>
                        <Icon iconName='icon-sm' className='icon_right invisible_icon' />
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            )
          }
        </div >
      </div >
    </li >
    : <li className='px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'>
      <div className='row'>
        <div className='col-12 px-0'>
          <a role='button' href='javascript:void(0)' aria-label={`${label}, este item possui submenus`} onClick={click(index)} className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'>
            <div className='row align-items-center h-100 pos-relative' aria-hidden>
              <div className='col ml-2 pt-half'>{label}</div>
              <div className='col-auto'>
                <div className='row mx-0'>
                  <div className='col-auto px-0 mx-auto'>
                    <Icon iconName='icon-sm' className='icon_right' />
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </li>
}

Items.propTypes = {
  items: PropTypes.array,
  path: PropTypes.string,
  click: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  closeMenu: PropTypes.func.isRequired,
  type: PropTypes.string
}

Items.defaultProps = {
  icon: 'icon_menu_app'
}
export default Items



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/Items/Items.js